<div class="container-fluid text-center py-9">
    <a [routerLink]="['/']">
        <img class="logo align-self-center" src="assets/img/logo-clicnote.svg">
    </a>
</div>
